import { render, staticRenderFns } from "./AddSongForm.vue?vue&type=template&id=7b4b780b&"
import script from "./AddSongForm.vue?vue&type=script&lang=js&"
export * from "./AddSongForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports